import { render, staticRenderFns } from "./YearData.vue?vue&type=template&id=08e8eb9d&scoped=true&"
import script from "./YearData.vue?vue&type=script&lang=js&"
export * from "./YearData.vue?vue&type=script&lang=js&"
import style0 from "./YearData.vue?vue&type=style&index=0&id=08e8eb9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8eb9d",
  null
  
)

export default component.exports